import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/si-tokens.css";

// Pages
import HomePage from "./pages/HomePage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import FlowJourney from './pages/FlowJourney';
import Community from './pages/Community';
import Organizations from './pages/Organizations';
import About from './pages/About';
import FlowIdentityAssessment from './pages/FlowIdentityAssessment';
import Manifesto from './pages/Manifesto';
import Books from './pages/Books';

//etc.
import Navbar from "./components/NavBar/Navbar.js";
import Footer from "./components/Footer.js";
import ScrollToTop from "./components/ScrollToTop.js";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/flow-journey" element={<FlowJourney />} />
        <Route path="/community" element={<Community/>} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/assessment" element={<FlowIdentityAssessment />} />
        <Route path="/manifesto" element={<Manifesto />} />
        <Route path="/books" element={<Books />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;